package com.example.mystybag.login.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_ADD_FIRST_BAG_SKIPPED_MERCHANT_ID
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_MERCHANT_ID
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.login.logic.NavigatorAddFirstBagPrompt
import com.example.mystybag.login.logic.NavigatorReturnToDashboard
import com.example.mystybag.login.logic.NavigatorReturnToLocations
import com.example.mystybag.login.model.AddFirstBagPromptUIState

class AddFirstBagPromptViewModel(
    context: AppContext,
    private val config: NavigatorAddFirstBagPrompt
) : ChildViewModel<AddFirstBagPromptUIState>(context, AddFirstBagPromptUIState()) {

    override fun onCreate() {
        navControls.backButtonVisible = false // Don't allow going back from this screen
    }

    fun onStartAddingBag() {
        // Navigate to add bag screen - same behavior as Dashboard "Add bag" button
        // Navigate directly to NavigatorAddBag via MainCallback
        // MystyBagDigitalWalletViewModel.popToMainAndNavigate will detect that we're already
        // on the AddFirstBagPrompt screen and navigate directly to NavigatorAddBag
        setResult<MainCallback> {
            popToMainAndNavigate(config)
        }
    }

    fun onSkipClicked() {
        // Remember that this merchant chose to skip, so dashboard won't redirect back to add first bag
        val merchantId = Preferences.getLong(key = PREFERENCES_MERCHANT_ID, 0L)
        if (merchantId != 0L) {
            Preferences.setLong(key = PREFERENCES_ADD_FIRST_BAG_SKIPPED_MERCHANT_ID, value = merchantId)
        }
        // After adding location we stay on Locations tab; otherwise return to Dashboard
        setResult<MainCallback> {
            popToMainAndNavigate(
                if (config.returnToDashboard) NavigatorReturnToDashboard else NavigatorReturnToLocations
            )
        }
    }
}
